import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { cn } from "@/lib/utils";

type Props = {
	/**
	 * Classes applied to the title/subtitle text column — used by callers to
	 * control responsive visibility, alignment and spacing (the topbar hides the
	 * text below `lg` and centers it; the drawer always shows it, left-aligned).
	 */
	textClassName?: string;
};

/**
 * The "MS" brand lockup — square logo tile + two-line title/subtitle. Shared by
 * `TopbarNav` (inside a hover `group` Link) and `DrawerNav` (static) so the tile
 * and text styling stay in sync. The `group-hover` tint is harmless where there
 * is no `group` ancestor.
 */
export const BrandMark = ({ textClassName }: Props) => {
	const { t } = useResource();
	return (
		<>
			<div className="bg-primary group-hover:bg-primary/90 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg transition-colors">
				<span className="text-primary-foreground text-body font-bold tracking-tight">
					MS
				</span>
			</div>
			<div className={cn("min-w-0 flex-col leading-tight", textClassName)}>
				<span className="text-foreground truncate text-body font-semibold">
					{t(Resources.Sidebar.BrandTitle)}
				</span>
				<span className="text-muted-foreground truncate text-micro">
					{t(Resources.Sidebar.BrandSubtitle)}
				</span>
			</div>
		</>
	);
};
